// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
import uuid from "react-native-uuid";
import { Loader, Toastr, Button, Tooltip } from "@revvsales/components";

// Components Imports
import AddReviewersSection from "./AddReviewersSection";
import ReviewerListSection from "./ReviewerListSection";
import SHIELD from "../../../assets/ic-shield.svg";
// Action Imports
import {
  addDocRecipientsAction,
  fetchDocRecipientListAction,
  sendForSignatureV2,
  deleteReviewersAction,
  editReviewerPermissionAction,
} from "../../../actions/DocumentActions";

// Services Imports
import { getAllTeammatesUsersService } from "../../../actions/UserActions/userService";

// Internal Imports
import { DocumentUtils, GlobalUtils, AmplitudeUtils } from "../../../utils";
import { EVENTS } from "../../../constants";

// Destructuring
const { readDataFromLocalStorage } = GlobalUtils;
const { _emailIsValid } = DocumentUtils;
const { amplitudeLogEvent } = AmplitudeUtils;

// DEcalarations
const RECIPIENT_DATA = {
  user_email: "",
  first_name: "",
  last_name: "",
  role: "Reviewer",
  id: 0,
  disabled: false,
  is_editable: false,
  isEdit: true,
};

class AddRecipientsPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errMsg: "",
      reviewersList: [],
      sharedReviewers: [],
      reviewerEmailMessage: "",
      showLoader: false,
      loader: false,
      showList: true,
      userOptions: [],
    };
  }

  componentDidMount() {
    this._fetchSharedReviewerList();
    this._fetchTeammates();
  }

  _fetchTeammates = async () => {
    const userData = await getAllTeammatesUsersService();
    if (
      userData.users &&
      Array.isArray(userData.users) &&
      userData.users.length > 0
    ) {
      userData.users.forEach(d => {
        d.value = d.id.toString();
        d.label = d.user_email;
      });
      this.setState({
        userOptions: userData.users,
      });
    }
  };

  _fetchSharedReviewerList = () => {
    const { document } = this.props;
    this.setState({
      showLoader: true,
    });
    this.props
      .fetchDocRecipientList(document.id)
      .then(response => {
        const { collaborators } = response;
        const data = [...collaborators];
        // Add the Signers and Default reviewer
        this._addSignerAndRecipientList(data);
      })
      .catch(() => {
        this._addSignerAndRecipientList([]);
        this.setState({
          showLoader: false,
        });
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Something went wrong. Please try again later.",
          timeout: 3000,
        });
      });
  };

  _checkToggleValue = (e, i) => {
    const data = [...this.state.reviewersList];
    data[i].is_editable = !data[i].is_editable;
    this.setState({ loader: true });
    console.debug(this.state.loader);
  };

  _showAndHideReviewerList = () => {
    this.setState(prevState => ({ showList: !prevState.showList }));
  };

  _addSignerAndRecipientList = sharedReviewers => {
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    let reviewersList = [{ ...RECIPIENT_DATA, id: uuid.v4() }];
    if (CURRENT_USER) {
      const {
        id: currentUserId,
        first_name: fname,
        last_name: lname,
        user_email: email,
      } = CURRENT_USER;
      // Check if the current user is already a reviewer
      let findCurrentUser;
      if (sharedReviewers && sharedReviewers.length > 0) {
        findCurrentUser = sharedReviewers.find(
          recp => recp.user && recp.user.id === currentUserId,
        );
      }
      // Check if the current user is already a signer
      if (!findCurrentUser && sharedReviewers && sharedReviewers.length === 0) {
        reviewersList = [
          {
            user_email: email,
            first_name: fname,
            last_name: lname,
            role: "Reviewer",
            id: uuid.v4(),
            disabled: false,
          },
          {
            ...RECIPIENT_DATA,
            id: uuid.v4(),
          },
        ];
      }
    }
    this.setState({
      reviewersList,
      sharedReviewers,
      showLoader: false,
    });
  };

  _addUserToTheList = () => {
    this.setState(prevState => {
      const cloneReviewerList = [...prevState.reviewersList];
      cloneReviewerList.push({
        ...RECIPIENT_DATA,
        id: uuid.v4(),
      });
      return { reviewersList: cloneReviewerList, errMsg: "" };
    });
  };

  _removeReviewer = index => {
    const data = [...this.state.reviewersList];
    data.splice(index, 1);
    this.setState(() => ({ reviewersList: data, errMsg: "" }));
  };

  // get users from the state for the validation
  _getUserStateData = email => {
    let stateUser = null;
    let stateUserIndex = null;
    for (let i = 0; i < this.state.reviewersList.length - 1; i += 1) {
      if (this.state.reviewersList[i].user_email === email) {
        stateUser = email;
        stateUserIndex = i;
      }
    }
    return { stateUser, stateUserIndex };
  };

  // Handle dynamic  Fields
  _handleValue = (eventData, i, name) => {
    const data = [...this.state.reviewersList];
    if (name === "user_email") {
      if (eventData === null) {
        data[i].disabled = false;
        data[i][name] = "";
        data[i].id = 0;
        data[i].first_name = "";
        data[i].last_name = "";
        data[i].is_editable = false;
        data[i].isEdit = false;
        this.setState({
          errMsg: "",
        });
      } else {
        data[i].disabled = false;
        data[i][name] = eventData.label;
        data[i].id = 0;
        data[i].first_name = "";
        data[i].last_name = "";
        data[i].is_editable = false;
        data[i].isEdit = false;
        if (
          eventData.label.length > 0 &&
          _emailIsValid(eventData.label) === false
        ) {
          data[i].notValid = true;
        } else {
          delete data[i].notValid;
          const { stateUser, stateUserIndex } = this._getUserStateData(
            eventData.label,
          ); // Get the user & it's index from state of current entered user
          const addedReviewerList = this.state.sharedReviewers
            ? this.state.sharedReviewers.find(
                item => item.user && item.user.user_email === eventData.label,
              )
            : null; // Get the user from already shared reviewers

          // const addedSignerList = this.state.signersList
          //   ? this.state.signersList.find(item => item.user_email === email)
          //   : null;
          // Case 1. if user exists in state "reviewersList"
          if (stateUser && stateUserIndex !== i) {
            data[i].disabled = true;
            this.setState({
              errMsg:
                "You've already added this contact as a recipient. Please click on the (x) button to clear the field and add a new one.",
              // isEdit: false,
            });
          }
          // Case 2. if user exists in alredy shared reviewers "sharedReviewers"
          else if (addedReviewerList) {
            data[i].disabled = true;
            this.setState({
              errMsg: "This reviewer has been already added.",
              // isEdit: false,
            });
          } else if (
            this.state.userOptions &&
            this.state.userOptions.length > 0
          ) {
            const findUser = this.state.userOptions.find(
              usr => usr.user_email === eventData.label,
            );
            if (findUser) {
              data[i].disabled = true;
              data[i].id = findUser.id;
              data[i].first_name = findUser.first_name;
              data[i].last_name = findUser.last_name;
              data[i].isEdit = true;
              this.setState({ errMsg: "" });
            }
          }
        }
      }
    } else {
      data[i][name] = eventData.target.value;
    }
    this.setState(() => ({ reviewersList: data }));
  };

  _removeAddedReviewer = reviewerId => {
    this.setState(
      prevState => {
        let cloneSharedReviewers = prevState.sharedReviewers;
        cloneSharedReviewers = cloneSharedReviewers.filter(
          recp => recp.user.id !== reviewerId,
        );
        return { sharedReviewers: cloneSharedReviewers };
      },
      () => {
        this._onRemoveUser(reviewerId);
      },
    );
  };

  _onRemoveUser = reviewerId => {
    const { document } = this.props;
    this.props
      .deleteReviewersAction(document.id, reviewerId)
      .then(() => {
        Toastr.showToastr({
          type: "success",
          message: "Access to this document successfully revoked for teammate.",
          timeout: 3000,
        });
      })
      .catch(err => {
        console.error(err);
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Something went wrong. Please try again later.",
          timeout: 3000,
        });
      });
  };

  _updateEditPermission = reviewerId => {
    const { document } = this.props;
    if (reviewerId === document.created_by.id) {
      Toastr.showToastr({
        type: "success",
        message: "Document owner's edit access cannot be switched off",
        timeout: 3000,
      });
      return;
    }
    const isEditable = this.state.sharedReviewers.find(
      usr => usr.user.id === reviewerId,
    ).is_editable;
    this.state.sharedReviewers.forEach(data => {
      if (data.user.id === reviewerId) {
        data.is_editable = !data.is_editable;
      }
    });
    this.props
      .editReviewerPermissionAction(document.id, reviewerId, !isEditable)
      .then(() => {
        Toastr.showToastr({
          type: "success",
          message: `${
            isEditable
              ? "Your teammate can only view the document now."
              : "Your teammate can now edit the document now."
          }`,
          timeout: 3000,
        });
      })
      .catch(err => {
        console.error(err);
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Something went wrong. Please try again later.",
          timeout: 3000,
        });
      });
  };

  _closePopup = () => {
    this.props.toggleModalPopUp("showAddRecipientsPopup", false);
  };

  _getShareDocumentPayload = () => {
    const { reviewersList } = this.state;
    const collaborators = [];
    if (reviewersList.length > 0) {
      reviewersList.forEach((reviewer, i) => {
        const tempObj = {
          is_editable: reviewer.is_editable,
          user_email: reviewer.user_email,
          first_name: reviewer.first_name,
          last_name: reviewer.last_name,
          recipientId: i + 1,
        };
        if (i === reviewersList.length - 1) {
          if (tempObj.user_email && tempObj.first_name && tempObj.last_name) {
            collaborators.push({ ...tempObj });
          }
        } else {
          collaborators.push({ ...tempObj });
        }
      });
    }
    // Not needed in the new reviewer flow
    // if (sharedReviewers && sharedReviewers.length > 0) {
    //   sharedReviewers.forEach((recp, i) => {
    //     collaborators.push({
    //       is_editable: recp.user.is_editable,
    //       user_email: recp.user.username,
    //       first_name: recp.user.first_name,
    //       last_name: recp.user.last_name,
    //       recipientId: i + 1,
    //     });
    //   });
    // }

    const data = {
      collaborators: [...collaborators],
      isReview: true,
      isEsign: false,
      reviewerEmailMessage: this.state.reviewerEmailMessage,
    };
    data.docName = this.props.document.name;
    return data;
  };

  _onSendDocument = () => {
    const payload = this._getShareDocumentPayload();
    this.setState({ showbtnLoader: true });
    this.props
      .addDocRecipientsAction(this.props.document.id, payload, "isReview")
      .then(() => {
        // If there are signers added then, call the sentForSiganture API,
        // else open the next popup
        if (
          payload.signers &&
          Array.isArray(payload.signers) &&
          payload.signers.length > 0
        ) {
          this._handleSendForSignature();
        } else {
          this.props.updateMultipleState({
            showAddRecipientsPopup: false,
            showDocStatusUpdateModal: true,
          });
        }
        const {
          id,
          template_id: templateID,
          documentStatus,
          documentTag,
        } = this.props.document;

        amplitudeLogEvent(EVENTS.EVENT_NAMES.DOCUMENT_SHARED, {
          documentID: id,
          templateID,
          status: documentStatus ? documentStatus.name : null,
          tag: documentTag ? documentTag.name : null,
          signerCount: payload.signers && payload.signers.length,
          reviewerCount: payload.collaborators && payload.collaborators.length,
        });
      })
      .catch(err => {
        this.setState({ showbtnLoader: false, showLoader: false });
        console.error(err);
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Something went wrong. Please try again later.",
          timeout: 3000,
        });
      });
  };

  _handleSendForSignature = () => {
    // const {
    //   id: documentID,
    //   template_id: templateID,
    //   documentStatus,
    //   documentTag,
    // } = this.props.document;
    // this.props
    //   .sendForSignatureV2(documentID)
    //   .then(() => {
    //     amplitudeLogEvent(EVENTS.EVENT_NAMES.DOCUMENT_SENT_FOR_SIGNATURE, {
    //       documentID,
    //       templateID,
    //       status: documentStatus ? documentStatus.name : null,
    //       tag: documentTag ? documentTag.name : null,
    //     });
    this.props.updateMultipleState({
      showAddRecipientsPopup: false,
      showDocStatusUpdateModal: true,
    });
    //   })
    //   .catch(() => {
    //     Toastr.showToastr({
    //       className: "is-failure",
    //       message: "Oops! Something went wrong. Please try again later.",
    //       timeout: 3000,
    //     });
    //     amplitudeLogEvent(EVENTS.EVENT_NAMES.DOCUMENT_SENT_FOR_SIGNATURE, {
    //       message: "Oops! Something went wrong. Please try again later.",
    //     });
    //   });
  };

  _changeReviewMessage = e => {
    this.setState({ reviewerEmailMessage: e.target.value });
  };

  _checkFormValidation = isSubmitBtn => {
    const { reviewersList } = this.state;
    let isValid = true;
    if (reviewersList && reviewersList.length > 0) {
      reviewersList.forEach((user, index) => {
        const { user_email: e, first_name: fn, last_name: ln } = user;
        if (e === "" || !_emailIsValid(e) || fn === "" || ln === "") {
          isValid = false;
        }
        if (
          isSubmitBtn &&
          reviewersList &&
          reviewersList.length > 1 &&
          reviewersList.length - 1 === index &&
          e === "" &&
          fn === "" &&
          ln === ""
        ) {
          isValid = true;
        }
      });
    } else if (isSubmitBtn) {
      isValid = false;
    }
    return isValid;
  };

  render() {
    const {
      reviewersList,
      showLoader,
      showbtnLoader,
      reviewerEmailMessage,
      showList,
      sharedReviewers,
      userOptions,
    } = this.state;
    // const { docRecipientList } = this.props;
    const {
      id: ownerId,
      user_email: ownerUserEmail,
    } = this.props.document.created_by;
    const errMsgSpace =
      this.state.errMsg !== "" ? (
        <div
          className="error-message-wrapper docsharingpopup-errormg-wrapper"
          data-test="doc-sharing-popup-error-message">
          {this.state.errMsg}
        </div>
      ) : null;

    let isBtnDisable = false;

    if (
      reviewersList &&
      reviewersList.length > 0 &&
      (reviewersList[0].user_email === "" ||
        reviewersList[0].first_name === "" ||
        reviewersList[0].last_name === "" ||
        reviewersList[0].notValid === true)
    ) {
      isBtnDisable = true;
    } else if (sharedReviewers && sharedReviewers.length === 0) {
      isBtnDisable = !this._checkFormValidation(true);
    }
    return (
      <Modal open onClose={this._closePopup} center closeOnOverlayClick={false}>
        {/* ----------- Loader Section ----------- */}
        {(showLoader || showbtnLoader) && (
          <Loader
            className="loader-bg-color"
            label={` ${showbtnLoader ? "Please wait..." : "Loading..."}`}
          />
        )}
        <div className="docrecipientspopup-container">
          {/* ----------- Modal Heading Section ----------- */}
          <div
            className="modal-heading"
            data-test="addrecipientspopup-modal-heading">
            Recipient Details
          </div>

          {errMsgSpace}

          {/* ----------- Added Signer List Section ----------- */}
          {/* {signersList && signersList.length > 0 && (
            <SignerListSection signersList={signersList} />
          )} */}

          <div className="docsharingpopup-sharingform-title">
            The following people will receive an email with the document link
          </div>

          <div className="addrecipientspopup-reviewers-section">
            {/* ----------- Add Reviewer List Section ----------- */}
            <AddReviewersSection
              ownerUserEmail={ownerUserEmail}
              // isEdit={isEdit}
              checkToggleValue={this._checkToggleValue}
              reviewersList={reviewersList}
              addUserToTheList={this._addUserToTheList}
              handleValue={this._handleValue}
              removeReviewer={this._removeReviewer}
              checkFormValidation={this._checkFormValidation}
              userOptions={userOptions}
            />
            <div className="docsharing-reviewer-email">
              <p className="docsharing-reviewer-email-subheading">
                Add a message for your recipients
              </p>
              <textarea
                rows="5"
                value={reviewerEmailMessage}
                onChange={e => this._changeReviewMessage(e)}
                data-test="addrecipientspopup-textarea"
              />
            </div>
            {/* ----------- Added  Reviewer List Section  ----------- */}

            {sharedReviewers && sharedReviewers.length > 0 && (
              <ReviewerListSection
                ownerId={ownerId}
                sharedReviewers={sharedReviewers}
                removeAddedReviewer={this._removeAddedReviewer}
                showAndHideReviewerList={this._showAndHideReviewerList}
                showList={showList}
                updateEditPermission={this._updateEditPermission}
              />
            )}
          </div>
          <div className="emptysigner-popup-warning-section">
            <div>
              <img src={SHIELD} alt="Revv" className="legal-signer-icon" />
            </div>
            <div>
              <div className="emptysigner-popup-legal-title">
                Legal, secure, reliable
              </div>
              <div className="emptysigner-popup-legal-subtitle">
                All document sent for review and eSign via Revv are in
                compliance with global signature laws.
              </div>
            </div>
          </div>

          {/* ----------- Modal Footer Section ----------- */}
          <div className="modal-footer">
            <Button
              id="addrecipientspopup-cancle-btn"
              className="btn btn-transparent modal-footer-btn cancle-btn"
              data-test="addrecipientspopup-cancle-btn"
              onClick={this._closePopup}>
              Cancel
            </Button>
            {isBtnDisable ? (
              <Tooltip
                placement="bottom"
                align={{
                  offset: [0, 4],
                }}
                overlay="Add recipient details to send document">
                <div className="tooltip-allowed">
                  <Button
                    id="addrecipientspopup-share-btn"
                    className="btn btn-primary modal-footer-btn submit-btn"
                    data-test="addrecipientspopup-share-btn"
                    disabled={isBtnDisable}
                    isLoading={showbtnLoader}
                    onClick={this._onSendDocument}>
                    Send document
                  </Button>
                </div>
              </Tooltip>
            ) : (
              <Button
                id="addrecipientspopup-share-btn"
                className="btn btn-primary modal-footer-btn submit-btn"
                data-test="addrecipientspopup-share-btn"
                isLoading={showbtnLoader}
                onClick={this._onSendDocument}>
                Send document
              </Button>
            )}
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  // ! IMP::
  // * IN ASSEST PAGE THERE IS AN OPTION TO SHARE THE DOCUMENT, TO HANDLE THAT CASE THIS TERNIARY OPERATOR LOGIC IS USED.
  // * NOW THE DATA NEEDED FOR THIS COMPONENT CAN EITHER BE FETCHED FROM REDUX OR SENT FROM PARENT COMPONENT
  // * SINCE AMPLITUDE NEEDS SOME ADDITIONAL DOCUMENT DATA INSTEAD OF JUST THE DOC ID THIS APPROACH WAS TAKEN

  const {
    document: documentDataFromRedux,
    docRecipientList,
  } = state.DocumentStore;
  const { document: documentDataFromParent, fromAssetPage } = ownProps;

  const document = fromAssetPage
    ? documentDataFromParent
    : documentDataFromRedux;
  return {
    document,
    docRecipientList,
  };
};

const mapDispatchToProps = {
  addDocRecipientsAction,
  fetchDocRecipientList: fetchDocRecipientListAction,
  sendForSignatureV2,
  deleteReviewersAction,
  editReviewerPermissionAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddRecipientsPopup);



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/AddRecipientsPopup/index.js